import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    FootNote,
    SizeCell,
    SplitCaKingCell,
    SplitKingCell,
    sizeIcons,
} from "./_shared";

import styles from "../../../styles/composable/product-specifications.module.scss";

/**
 * Native port of ``cms/blocks/product-specifications/proadapt.html`` (#33410).
 * Same eight size cells as Adapt (every ``static_image`` here passes ``alt=""``)
 * with ProAdapt weight ranges.
 */
export const ProAdapt = (): React.JSX.Element => (
    <div
        className={concatClassNames([
            "adapt-specifications",
            styles.specifications,
        ])}
    >
        <SizeCell
            icon={sizeIcons.adaptTwin}
            heading="Twin"
            lines={['38" x 74"', "Single Mattress", "52-72 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptTwinXl}
            heading="Twin Long"
            lines={['38" x 80"', "Single Mattress", "56-75 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptDouble}
            heading="Full/Double"
            lines={['53" x 74"', "Single Mattress", "72-98 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptQueen}
            heading="Queen"
            lines={['60" x 80"', "Single Mattress", "86-119 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptKing}
            heading="King"
            lines={['76" x 80"', "Single Mattress", "108-151 lbs"]}
        />
        <SplitKingCell
            lines={['76" x 80"', "Double Mattress", "112-150 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptCaKing}
            heading="CA King"
            lines={['72" x 84"', "Single Mattress", "108-151 lbs"]}
        />
        <SplitCaKingCell
            lines={['72" x 84"', "Double Mattress", "114-152 lbs"]}
        />

        <FootNote />
    </div>
);
